import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../context/AuthContext';
import { withRouter, generatePath } from "react-router-dom";
import history from '../history';

import Button from 'react-bootstrap/esm/Button';
import Container from 'react-bootstrap/esm/Container';
import { Card } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Modal from 'react-bootstrap/Modal';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import Collapsible from 'react-collapsible';
import { ListManager } from 'react-beautiful-dnd-grid';
import LoadingOverlay from 'react-loading-overlay';
import Switch from "react-switch";

const MorphingRetrievalCataloguePage = () => {
    let { isAuthenticated, authTokens, user, url } = useContext(AuthContext)

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        if (initialPathsEg === finalPathsEg || initialPathsFp === finalPathsFp) {
            setShow(true)
        }
        else {
            handleSubmit()
        }
    };

    const [isActive, setIsActive] = useState(false)

    const [showToast, setShowToast] = useState(false);

    const [direction, setDirection] = useState("horizontal");

    const [queryPatientImage, setQueryPatientImage] = useState(null)
    const [catalogue_id, setCatalogue_id] = useState(null)
    const [catalogue_type, setCatalogue_type] = useState(null)
    const [catalogue_number, setCatalogue_number] = useState(null)
    const [max_number, setMaxNumber] = useState(0)

    const [end, setEnd] = useState(false)

    const [initialPathsEg, setInitialPathsEg] = useState([])
    const [finalPathsEg, setFinalPathsEg] = useState([])

    const [initialPathsFp, setInitialPathsFp] = useState([])
    const [finalPathsFp, setFinalPathsFp] = useState([])

    useEffect(() => {
        const mediaQuery = window.matchMedia("(max-width: 600px)");

        const handleMediaQueryChange = (e) => {
            setDirection(e.matches ? "vertical" : "horizontal");
        };

        handleMediaQueryChange(mediaQuery);

        mediaQuery.addEventListener("change", handleMediaQueryChange);

        getImages()

        return () => mediaQuery.removeEventListener("change", handleMediaQueryChange);
    }, []);

    let getImages = async () => {
        setIsActive(true)
        let response = await fetch('https://breloai-backend.inesctec.pt/api/compareMorphingRetrieval/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({ "action": "catalogue", "catalogue_id": catalogue_id, "catalogue_number": catalogue_number })
        })
        let data = await response.json()
        if (response.status === 200) {
            setQueryPatientImage(data['query_image_path'])
            setCatalogue_id(data['catalogue_id'])
            setCatalogue_type(data['catalogue_type'])
            setCatalogue_number(data['catalogue_number'])
            setInitialPathsEg(data['initial_paths_eg'])
            setFinalPathsEg(data['initial_paths_eg'])
            setInitialPathsFp(data['initial_paths_fp'])
            setFinalPathsFp(data['initial_paths_fp'])
            if (data['catalogue_number'] > max_number) {
                setMaxNumber(data['catalogue_number'])
            }
        }
        else if (response.status === 202) {
            setQueryPatientImage(null)
            setCatalogue_id(null)
            setCatalogue_type(null)
            setCatalogue_number(null)
            setEnd(true)
            setInitialPathsEg(null)
            setFinalPathsEg(null)
            setInitialPathsFp(null)
            setFinalPathsFp(null)
        }
        else {
            console.log("ups")
        }
        await new Promise(r => setTimeout(r, 300));
        setIsActive(false)
    }

    let handleSubmit = async () => {
        let response = await fetch('https://breloai-backend.inesctec.pt/api/compareMorphingRetrieval/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({ "action": "update_catalogue", "final_order_eg": finalPathsEg, "final_order_fp": finalPathsFp, "catalogue_id": catalogue_id, "catalogue_number": catalogue_number })
        })
        if (response.status === 200) {
            getImages()
        }
        else if (response.status === 202) {
            setQueryPatientImage(null)
            setCatalogue_id(null)
            setCatalogue_type(null)
            setCatalogue_number(null)
            setEnd(true)
            setInitialPathsEg(null)
            setFinalPathsEg(null)
            setInitialPathsFp(null)
            setFinalPathsFp(null)
        }
        handleClose()
    }

    let previousCatalogue = async () => {
        setIsActive(true)
        let response = await fetch('https://breloai-backend.inesctec.pt/api/compareMorphingRetrieval/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({ "action": "retrieve_catalogue", "catalogue_number": catalogue_number - 1 })
        })
        let data = await response.json()
        if (response.status === 200) {
            setQueryPatientImage(data['query_image_path'])
            setCatalogue_id(data['catalogue_id'])
            setCatalogue_type(data['catalogue_type'])
            setCatalogue_number(data['catalogue_number'])
            setInitialPathsEg(data['initial_paths_eg'])
            setFinalPathsEg(data['initial_paths_eg'])
            setInitialPathsFp(data['initial_paths_fp'])
            setFinalPathsFp(data['initial_paths_fp'])
        }
        await new Promise(r => setTimeout(r, 300));
        setIsActive(false)
    }

    let nextCatalogue = async () => {
        setIsActive(true)
        let response = await fetch('https://breloai-backend.inesctec.pt/api/compareMorphingRetrieval/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({ "action": "retrieve_catalogue", "catalogue_number": catalogue_number + 1 })
        })
        let data = await response.json()
        if (response.status === 200) {
            setQueryPatientImage(data['query_image_path'])
            setCatalogue_id(data['catalogue_id'])
            setCatalogue_type(data['catalogue_type'])
            setCatalogue_number(data['catalogue_number'])
            setInitialPathsEg(data['initial_paths_eg'])
            setFinalPathsEg(data['initial_paths_eg'])
            setInitialPathsFp(data['initial_paths_fp'])
            setFinalPathsFp(data['initial_paths_fp'])
        }
        await new Promise(r => setTimeout(r, 300));
        setIsActive(false)
    }

    let handleOnDragEg = (sourceIndex, destinationIndex) => {
        const items = Array.from(finalPathsEg)
        const [reorderItem] = items.splice(sourceIndex, 1)
        items.splice(destinationIndex, 0, reorderItem)

        setFinalPathsEg(items)
    }

    let handleOnDragFp = (sourceIndex, destinationIndex) => {
        const items = Array.from(finalPathsFp)
        const [reorderItem] = items.splice(sourceIndex, 1)
        items.splice(destinationIndex, 0, reorderItem)

        setFinalPathsFp(items)
    }

    let downloadCatalogues = async () => {
        let response = await fetch('https://breloai-backend.inesctec.pt/api/compareMorphingRetrieval/', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
        })
        let data = await response
        if (response.status === 200) {
            setShowToast(true)
        }
    }

    let sides = [2, 1, 2, 2, 1, 1, 2, 1, 1, 1, 1, 1, 2, 1, 1, 1]
    let surgery_types = [1, 1, 1, 1, 2, 1, 1, 4, 1, 2, 2, 1, 1, 2, 2, 2]

    return (
        <Container style={{ minWidth: '100vw' }}>
            <Breadcrumb>
                <Breadcrumb.Item onClick={() => history.push(generatePath("/"))}>Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item active>
                    Morphing Page
                </Breadcrumb.Item>
            </Breadcrumb>

            <ToastContainer className="mt-5" position="top-center">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={3000} autohide bg='success'>
                    <Toast.Header>
                        <strong className="me-auto">Download Successful</strong>
                    </Toast.Header>
                    <Toast.Body>
                        Go to the '/media/csvs' in the CINDERELLA NAS.
                    </Toast.Body>
                </Toast>
            </ToastContainer>

            {
                user !== null ?
                    user.is_staff ?
                        <Container>
                            <div className='addPatient-div'>
                                <Button variant="outline-primary" className="addPatient-button" onClick={() => downloadCatalogues()}><i className="fa fa-download" aria-hidden="true"></i> Download Morphing Data</Button>
                            </div>
                        </Container> :
                        null
                    :
                    null
            }

            {
                end ?

                    <div className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                        <h2>There are no more catalogues. Thank you for your help!</h2>
                    </div>

                    :
                    <div>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>Breast to change: {sides[catalogue_number - 1] == 1 ? "Left" : "Right"}</span>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>Surgery Type: {surgery_types[catalogue_number - 1] == 1 ? "C1 - Conservative Surgery" : surgery_types[catalogue_number - 1] == 2 ? "C2 - Conservative Surgery with bilateral reduction" : surgery_types[catalogue_number - 1] == 4 ? "C4 - Conservative Surgery with bilateral implants" : null}</span>
                        <span style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>{catalogue_number}/16</span>
                        <div className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center', }}>
                            {
                                <Button disabled={catalogue_number == 1 ? true : false} variant="outline-primary morphingButton" className="addPatient-button" onClick={() => previousCatalogue()}><i class="fa-solid fa-arrow-left" aria-hidden="true"></i> Previous </Button>
                            }

                            <Card className="text-center queryCardMorphing mx-4" style={{ width: '20vw' }}>
                                <Card.Header style={{ backgroundColor: "white" }}>Query Patient</Card.Header>
                                <Card.Img variant="top" src={queryPatientImage === null ? 'https://breloai-backend.inesctec.pt/media/default.jpeg' : 'https://breloai-backend.inesctec.pt' + queryPatientImage} width="250" height="250" />
                            </Card>

                            {
                                <Button disabled={max_number == catalogue_number ? true : false} variant="outline-primary morphingButton" className="addPatient-button" onClick={() => nextCatalogue()}><i class="fa-solid fa-arrow-right" aria-hidden="true"></i> Next </Button>
                            }
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', margin: '2vw' }}>
                            <span style={{ display: "flex", alignItems: "center", justifyContent: 'center', marginRight: '1vw' }}>Order the images from left to right based on how helpful they are at showcasing the potential outcomes of the surgery!</span>
                        </div>
                        <LoadingOverlay active={isActive} spinner>

                            <hr style={{ height: 6, backgroundColor: 'black', color: 'black', borderRadius: 5 }}></hr>
                            <h2>Excellent and Good</h2>
                            {
                                finalPathsEg !== null ?
                                    finalPathsEg.length === 0 ?
                                        <h4 className='text-center mb-4'>No results.</h4>
                                        :
                                        <ListManager
                                            items={finalPathsEg}
                                            direction={direction}
                                            maxItems={4}
                                            render={(path) => {
                                                return (
                                                    <Card className='text-center mx-4 my-2'>
                                                        <Card.Body>
                                                            <Card.Img variant='bottom' src={'https://breloai-backend.inesctec.pt' + path} width="250" height="250"></Card.Img>
                                                        </Card.Body>
                                                    </Card>
                                                );
                                            }}
                                            onDragEnd={handleOnDragEg}
                                        />
                                    :
                                    null
                            }
                            <hr style={{ height: 6, backgroundColor: 'black', color: 'black', borderRadius: 5 }}></hr>

                            <h2>Fair and Poor</h2>
                            {
                                finalPathsFp !== null ?
                                    finalPathsFp.length === 0 ?
                                        <h4 className='text-center mb-4'>No results.</h4>
                                        :
                                        <ListManager
                                            items={finalPathsFp}
                                            direction={direction}
                                            maxItems={4}
                                            render={(path) => {
                                                return (
                                                    <Card className='text-center mx-4 my-2'>
                                                        <Card.Body>
                                                            <Card.Img variant='bottom' src={'https://breloai-backend.inesctec.pt' + path} width="250" height="250"></Card.Img>
                                                        </Card.Body>
                                                    </Card>
                                                );
                                            }}
                                            onDragEnd={handleOnDragFp}
                                        />
                                    :
                                    null
                            }
                            <hr style={{ height: 6, backgroundColor: 'black', color: 'black', borderRadius: 5 }}></hr>

                            <Container className='mb-4' style={{ display: "flex", alignItems: "center", justifyContent: 'center' }}>

                                <Button className='FilledButton my-3 mx-1' onClick={handleShow}><i className="fa-solid fa-upload"></i> Submit Catalogue </Button>

                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Submit Catalogue</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        You have not made any changes to the catalogues. Are you sure you want to proceed?
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Cancel
                                        </Button>
                                        <Button variant="danger" onClick={() => handleSubmit()}>
                                            Confirm
                                        </Button>
                                    </Modal.Footer>
                                </Modal>

                            </Container>

                        </LoadingOverlay>

                        {/*fullscreenImage && (
                            <div
                                className="fullscreen-overlay"
                                onClick={closeFullscreen}
                                style={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100vw",
                                    height: "100vh",
                                    backgroundColor: "rgba(0, 0, 0, 0.9)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 9999,
                                    cursor: "pointer",
                                }}
                            >
                                <img
                                    src={fullscreenImage}
                                    alt="Fullscreen View"
                                    style={{
                                        maxWidth: "90%",
                                        maxHeight: "90%",
                                        objectFit: "contain",
                                    }}
                                />
                            </div>
                        )*/}
                    </div >
            }
        </Container >

    )
}

export default withRouter(MorphingRetrievalCataloguePage)